import type { CampaignColumn } from 'services/campaignColumns'

import { MANUAL_COLUMN_AGENT_TYPE } from './agentTypeMetadata'

export function campaignColumnHasPendingCompute(column: CampaignColumn) {
  if (column.engine_type === MANUAL_COLUMN_AGENT_TYPE) return false

  const { total_contacts: total, computed, failed } = column.progress
  return computed + failed < total
}
